//============================================================================
// Name        : summarization_stats.ts
// Purpose     : Implement Charting for summarization stats page
// Created     : 2020-08-24
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import Chart from "chart.js";
import {InitPage} from "../index";

declare const durationPoints;
declare const connectionPoints;
declare const timePoints;

class SummarizationStats {
    constructor() {
        const canvas = document.getElementById("statsChart") as HTMLCanvasElement;
        const ctx    = canvas.getContext("2d");
        const statsChart = new Chart(ctx, {
            type: "line",
            data: {
                labels: timePoints,
                datasets: [{
                    label: "Duration Secs",
                    data: durationPoints,
                    backgroundColor: [
                        "rgba(139, 206, 240, 0.3)"
                    ],
                    borderColor: [
                        "rgba(139, 206, 240, 1)"
                    ],
                    borderWidth: 1
                }, {
                    label: "# of Connections",
                    data: connectionPoints,
                    backgroundColor: [
                        "rgba(139, 240, 173, 0.15)"
                    ],
                    borderColor: [
                        "rgba(139, 240, 173, 1)"
                    ],
                    borderWidth: 1,
                    hidden: true
                }]
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            }
        });
    }
}

export function LoadPage() {
    InitPage("reports_and_logs summarization_stats", () => {
        const c = new SummarizationStats();
    });
}
